import { AbstractControl, ValidationErrors } from '@angular/forms';

export class WhiteSpaceValidator {
    static cannotContainSpace(control: AbstractControl): ValidationErrors | null {
        let final: string = String(control.value.trim());
        if (final.length == 0) {
            return { cannotContainSpace: true }
        }
        return null;
    }

    static cannontStartWithSpace(control: AbstractControl): ValidationErrors | null {
        
        let start: boolean = control.value.startsWith(' ');

        if (start) {
            return {startWithSpace: true}
        }

        return null;
    }
}